export default __webpack_public_path__ + "static/atrium_img2-558d6841e76897dcc1cedef3620da68c.png";